module.exports = __webpack_public_path__ + "static/media/ChangeStyling.8726c5e5.gif";